import React, { Component } from "react";
import ActualEnterprises from "../components/Search/ActualEnterprises";
import ProcessingEnterpriseHttpAdapter from "../apiClient/ProcessingEnterpriseHttpAdapter";
import Preloader from '../components/Preloader';

class ActualEnterprisesPage extends Component {

  componentDidMount() {
    ProcessingEnterpriseHttpAdapter.getActual().subscribe(regionsWithActualEnterprises => {
      this.regionsWithActualEnterprises = regionsWithActualEnterprises;
      this.forceUpdate();
    });
  }

  render() {
    return (
      <div className="container-search-page">
        {!this.regionsWithActualEnterprises ?
          <Preloader /> :
          <ActualEnterprises regionsWithActualEnterprises={this.regionsWithActualEnterprises}/>
        }
      </div>
    );
  }
}

export default ActualEnterprisesPage;


// WEBPACK FOOTER //
// ./containers/ActualEnterprisesPage.js